import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import localeEs from 'date-fns/locale/es';
import { format } from 'date-fns';
import moment from 'moment';

/** API */
import { isDate } from 'lodash';
import { API } from '../../../constants/api';
import {
  getParticipateEvent,
  participateEvent,
  noParticipateEvent,
  getEvent
} from '../../../utils/apiEvents';

/**
 * Styles
 */
import { StyledCalendarEventHour, WrapperHour, BgHour } from './style';

import Button from '../Buttons';

import {
  Event,
  DivFlex,
  DivScroll,
  DivCenter,
  IconsEvent,
  IconEventClose,
  StrongMedium,
  DayMonthEvent,
  TitleEvent,
  ElementEvent,
  DescEvent,
  DateEvent,
  DateRange,
  LinksEvent,
  LinkNews,
  StyledDates
} from './styleCaledarEventHour';

/**
 * Images
 */
import { Close, Diary, Reloj, DirGeo, Clip } from '../../../../assets/images';

const getDays = (eventDays, item) =>
  !(eventDays.length > 1 && item.eventHour === '');

/** return moment of the event */

const getEventMoment = (type, dataEvent, event) => {
  let indexSelected = 0;
  let dd = 'Hoy';
  let date;
  if (type === 'Inicio') {
    indexSelected = 0;
    if (event) {
      const DD = new Date(event.startDate);
      dd = format(DD, 'DD MMMM', {
        locale: localeEs
      });
    }
    const start = isDate(new Date(event?.startDate))
      ? `- ${moment(new Date(event?.startDate)).format('HH:mm')}`
      : '';

    date = dataEvent?.eventDays?.length
      ? `${format(dataEvent.eventDays[indexSelected].eventDay, 'DD MMMM', {
          locale: localeEs
        })} ${start}`
      : `${dd} ${start}`;
  } else {
    indexSelected = dataEvent?.eventDays?.length - 1;
    if (event) {
      const DD = new Date(event.closeDate);
      dd = format(DD, 'DD MMMM', {
        locale: localeEs
      });
    }

    const close = isDate(new Date(event?.closeDate))
      ? `- ${moment(new Date(event?.closeDate)).format('HH:mm')}`
      : '';
    date = dataEvent?.eventDays?.length
      ? `${format(dataEvent.eventDays[indexSelected].eventDay, 'DD MMMM', {
          locale: localeEs
        })} ${close}`
      : `${dd} ${close}`;
  }
  return `${type} ${date}`;
};

const controlParticipate = event => {
  const DD = new Date();
  const start = new Date(event.startDate);
  const end = new Date(event.closeDate);
  return DD >= start && DD <= end;
};

const CalendarEventHour = ({
  className,
  dataEvent,
  daySelected,
  onClick,
  user
}) => {
  const [participe, setParticipe] = useState(false);
  const [event, setEvent] = useState(null);
  const [control, setControl] = useState(false);
  useEffect(() => {
    getParticipateEvent(dataEvent.id)
      .then(data => setParticipe(data))
      .catch(() => setParticipe(false));
    getEvent(dataEvent.id).then(data => {
      setEvent(data);
      setControl(controlParticipate(data));
    });
  }, []);
  const renderParticipate = participe ? 'Dejar de participar' : 'Participar';
  return (
    <Fragment>
      <BgHour />
      <WrapperHour>
        <StyledCalendarEventHour className={`${className} event-hour`}>
          <Event className="event-hour-form">
            <IconEventClose
              onClick={onClick}
              svg={Close}
              color="dark"
              size="m"
            />
            <DivCenter>
              <DivFlex>
                <IconsEvent svg={Diary} hover={false} size="m" color="dark" />
                <DayMonthEvent
                  date={daySelected || dataEvent.eventDate}
                  dayNumber
                  month
                  dayText
                  className="event-hour-date"
                />
              </DivFlex>
              <div>
                <StyledDates>
                  {getEventMoment('Inicio', dataEvent, event)}
                </StyledDates>
                <StyledDates>
                  {getEventMoment('Fin', dataEvent, event)}
                </StyledDates>
              </div>
              <TitleEvent className="event-hour-title">
                {dataEvent.eventName}
              </TitleEvent>
              <DivScroll>
                {dataEvent.authorVisible && dataEvent.eventConvener && (
                  <ElementEvent>
                    <span>Convoca:</span>
                    &nbsp;
                    <strong>{dataEvent.eventConvener}</strong>
                  </ElementEvent>
                )}
                <DateEvent>
                  {dataEvent?.eventDays?.length > 0 &&
                    dataEvent?.eventDays[0]?.eventHour && (
                      <IconsEvent
                        svg={Reloj}
                        hover={false}
                        size="m"
                        color="dark"
                      />
                    )}
                  <div>
                    {dataEvent.eventDays &&
                      dataEvent.eventDays.map(
                        item =>
                          getDays(dataEvent.eventDays, item) && (
                            <DateRange
                              key={`${item.eventDay}-${item.eventHour}`}
                              dateTime={format(item.eventDay, 'YYYY-MM-DD')}
                            >
                              <StrongMedium>
                                {format(item.eventDay, 'DD MMMM', {
                                  locale: localeEs
                                })}
                                :{' '}
                                {item.eventHour
                                  ? item.eventHour
                                  : `${dataEvent.startDate} - ${dataEvent.closeDate}`}
                              </StrongMedium>
                            </DateRange>
                          )
                      )}
                  </div>
                </DateEvent>

                {dataEvent.eventLocation && (
                  <ElementEvent>
                    <IconsEvent
                      svg={DirGeo}
                      hover={false}
                      size="m"
                      color="dark"
                    />
                    <span>{dataEvent.eventLocation}</span>
                  </ElementEvent>
                )}
                {dataEvent.docEvent && (
                  <ElementEvent>
                    <IconsEvent
                      svg={Clip}
                      hover={false}
                      size="m"
                      color="dark"
                    />
                    <LinksEvent
                      href={`${API}files/files${dataEvent.docEventPath}`}
                      target="_blank"
                    >
                      {dataEvent.docEvent}
                    </LinksEvent>
                  </ElementEvent>
                )}
                <DescEvent>{dataEvent.descriptionEvent}</DescEvent>
                {event && event.linkNews !== '' && (
                  <ElementEvent>
                    <LinkNews href={event.linkNews}>+ Ir a noticia</LinkNews>
                  </ElementEvent>
                )}
                {event &&
                  event.eventType === 'DRAW' &&
                  event.subscribable &&
                  control && (
                    <React.Fragment>
                      {dataEvent.onlyInternal ? (
                        user.typology === 'INTERNAL' && (
                          <ElementEvent>
                            <Button
                              secondary
                              onClick={() =>
                                participe
                                  ? noParticipateEvent(dataEvent.id).then(() =>
                                      setParticipe(!participe)
                                    )
                                  : participateEvent(dataEvent.id).then(() =>
                                      setParticipe(!participe)
                                    )
                              }
                            >
                              {renderParticipate}
                            </Button>
                          </ElementEvent>
                        )
                      ) : (
                        <ElementEvent>
                          <Button
                            secondary
                            onClick={() =>
                              participe
                                ? noParticipateEvent(dataEvent.id).then(() =>
                                    setParticipe(!participe)
                                  )
                                : participateEvent(dataEvent.id).then(() =>
                                    setParticipe(!participe)
                                  )
                            }
                          >
                            {renderParticipate}
                          </Button>
                        </ElementEvent>
                      )}
                    </React.Fragment>
                  )}
              </DivScroll>
            </DivCenter>
          </Event>
        </StyledCalendarEventHour>
      </WrapperHour>
    </Fragment>
  );
};

CalendarEventHour.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  dataEvent: PropTypes.shape({
    eventName: PropTypes.string,
    eventDate: PropTypes.string,
    eventConvener: PropTypes.string,
    authorVisible: PropTypes.bool,
    eventLocation: PropTypes.string,
    docEvent: PropTypes.string,
    type: PropTypes.string,
    descriptionEvent: PropTypes.string,
    linkNews: PropTypes.string,
    startDate: PropTypes.string,
    closeDate: PropTypes.string,
    eventDays: PropTypes.arrayOf(
      PropTypes.shape({
        eventDay: PropTypes.string,
        eventHour: PropTypes.string
      })
    )
  }).isRequired
};

export default CalendarEventHour;
